<template>
  <div class="w-full">
    <AppHeader />


    <!-- 4. Top Banner / Hero -->
    <div v-if="heroBanners.length" class="flex flex-col gap-[12px] sm:gap-[24px] items-center py-[14px] sm:py-[30px] w-full px-[16px] lg:px-0">
      <div class="aspect-[1140/300] sm:aspect-auto sm:h-[300px] overflow-hidden relative rounded-[16px] sm:rounded-[40px] w-full max-w-[1240px] bg-[#f4f6f8]">
        <img
          :key="currentHeroBanner.imageUrl"
          :src="currentHeroBanner.imageUrl"
          :alt="currentHeroBanner.title || 'GOLDNARA main banner'"
          class="absolute inset-0 h-full w-full object-cover object-center"
        />
        <!-- 텍스트/버튼 임시 숨김 -->
        <!-- <div class="absolute inset-0 flex items-center justify-end pr-[32px] sm:pr-[60px] lg:pr-[80px]">
          <div class="flex flex-col gap-[8px] sm:gap-[12px] items-start">
            <div class="flex flex-col gap-[2px] sm:gap-[4px]">
              <p class="font-bold text-white text-[20px] sm:text-[32px] lg:text-[40px] leading-tight">골드나라 아우라 실버바</p>
              <p class="font-semibold text-white text-[12px] sm:text-[16px] lg:text-[20px] tracking-wide">GOLDNARA AURA Silver Bar</p>
            </div>
            <p class="text-white/70 text-[10px] sm:text-[13px] leading-relaxed hidden sm:block">정품 인증 시리얼 넘버 및 잠상 기법 / 순도 999.9% / 1000g</p>
            <button
              type="button"
              class="border border-white border-solid text-white text-[11px] sm:text-[13px] font-medium px-[16px] sm:px-[24px] py-[6px] sm:py-[10px] rounded-full mt-[4px] hover:bg-white hover:text-black transition-colors"
            >
              VIEW MORE
            </button>
          </div>
        </div> -->
      </div>
      <div v-if="heroBanners.length > 1" class="flex gap-[16px] items-center justify-between sm:justify-end max-w-[1240px] w-full mx-auto">
        <div class="h-[8px] w-[168px] flex gap-[8px] items-center">
          <button
            v-for="idx in heroDots"
            :key="idx"
            type="button"
            class="rounded-full"
            :class="idx === activeHeroDot ? 'bg-[#3a4250] w-[24px] h-[8px]' : 'bg-[#d7d7d7] size-[8px]'"
            :aria-label="`${idx + 1}번째 메인 배너 보기`"
            @click="goHero(idx)"
          ></button>
        </div>
        <div class="flex gap-[16px] items-center">
          <button
            type="button"
            class="bg-[#e8e8e8] rounded-full shrink-0 size-[36px] flex items-center justify-center"
            @click="prevHero"
          >
            <svg class="size-[20px] text-[#3a4250]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="m15 18-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button
            type="button"
            class="bg-[#e8e8e8] rounded-full shrink-0 size-[36px] flex items-center justify-center"
            @click="nextHero"
          >
            <svg class="size-[20px] text-[#3a4250]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="m9 18 6-6-6-6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 5. Trust Metrics -->
    <div class="mx-auto flex w-full max-w-[1240px] items-center justify-center px-[16px] py-[22px] sm:py-[42px] lg:px-0">
      <div class="trust-metrics flex w-full items-stretch justify-center bg-white">
        <div class="trust-metric-item flex flex-1 flex-col items-center justify-center gap-[8px] px-[7px] text-center sm:min-h-[96px] sm:gap-[12px] sm:px-[12px]">
          <p class="trust-metric-number font-bold leading-tight text-[#111111]">
            <span class="hidden sm:inline">{{ transactionAmount.toLocaleString() }}원</span>
            <span class="sm:hidden">{{ compactAmount(transactionAmount) }}</span>
          </p>
          <p class="trust-metric-label font-normal leading-tight text-[#48566a]">누적 거래금액</p>
        </div>
        <div class="h-[42px] w-px shrink-0 self-center bg-[#1f3a5a]"></div>
        <div class="trust-metric-item flex flex-1 flex-col items-center justify-center gap-[8px] px-[7px] text-center sm:min-h-[96px] sm:gap-[12px] sm:px-[12px]">
          <p class="trust-metric-number font-bold leading-tight text-[#111111]">
            <span class="hidden sm:inline">{{ visitorCount.toLocaleString() }}명</span>
            <span class="sm:hidden">{{ compactCount(visitorCount) }}</span>
          </p>
          <p class="trust-metric-label font-normal leading-tight text-[#48566a]">누적 거래고객</p>
        </div>
        <div class="h-[42px] w-px shrink-0 self-center bg-[#1f3a5a]"></div>
        <div class="trust-metric-item flex flex-1 flex-col items-center justify-center gap-[8px] px-[7px] text-center sm:min-h-[96px] sm:gap-[12px] sm:px-[12px]">
          <p class="trust-metric-number font-bold leading-tight text-[#111111]">{{ branchPartnerCount.toLocaleString() }}개</p>
          <p class="trust-metric-label font-normal leading-tight text-[#48566a]">누적 지점/가맹점</p>
        </div>
      </div>
    </div>

    <!-- 8. Page disclaimer #1 - 8 product grid -->
    <div class="flex flex-col gap-[18px] sm:gap-[32px] items-start py-[32px] sm:py-[70px] max-w-[1240px] w-full mx-auto px-[16px] lg:px-0">
      <div class="flex items-center justify-between w-full whitespace-nowrap">
        <p class="font-bold text-[#202632] text-[16px] sm:text-[24px]">주요 브랜드</p>
        <router-link to="/products" class="text-[#3a4250] text-[12px] sm:text-[14px] hover:text-[#3e6fb3] transition-colors">상품 전체보기 →</router-link>
      </div>
      <div v-if="productLabelTabs.length" class="flex w-full gap-[18px] overflow-x-auto border-b border-[#d9dee7] pb-[8px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:gap-[22px]">
        <button
          v-for="label in productLabelTabs"
          :key="label.productLabelCode"
          type="button"
          class="shrink-0 border-b-2 pb-[7px] text-[14px] font-semibold transition-colors sm:text-[15px]"
          :class="activeProductLabelKey === label.labelKey ? 'border-[#0072ce] text-[#0072ce]' : 'border-transparent text-[#00284a] hover:text-[#0072ce]'"
          @click="selectProductLabel(label.labelKey)"
        >
          {{ label.badgeText || label.labelName }}
        </button>
      </div>
      <div v-if="mainDisplayLoaded && mainProducts.length" class="relative w-full">
        <button
          v-if="mainProducts.length > 4"
          type="button"
          class="carousel-nav carousel-nav--left"
          aria-label="이전 주요브렌드 보기"
          @click="scrollProductRow('mainProductsScroller', -1)"
        >
          ‹
        </button>
        <div ref="mainProductsScroller" class="product-carousel-row">
          <div
            v-for="(product, idx) in mainProducts"
            :key="idx"
            class="mall-product-card product-carousel-card relative overflow-hidden flex flex-col cursor-pointer"
          role="link"
          tabindex="0"
          @click="goDisplayProduct(product)"
          @keydown.enter.prevent="goDisplayProduct(product)"
        >
          <span v-if="product.discountRateText" class="discount-badge">
            <span class="discount-badge__rate">{{ product.discountRateText }}</span>
          </span>
          <div class="relative h-[178px] sm:h-[260px] bg-[#f8f9fb] flex items-center justify-center p-[14px] sm:p-[20px] shrink-0 w-full">
            <img v-if="product.image" :src="product.image" :alt="product.title" class="w-full h-full object-contain" />
            <div v-else class="w-[120px] h-[120px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[#8a8f99] text-[12px]">
              이미지 없음
            </div>
          </div>
          <div class="p-[12px] sm:p-[16px] flex flex-col gap-[8px] sm:gap-[10px] grow w-full">
            <div v-if="product.labels.length" class="flex min-h-[26px] flex-wrap items-center gap-[6px]">
              <span
                v-for="(label, labelIndex) in product.labels"
                :key="label.productLabelCode"
                class="product-label-badge"
                :class="labelBadgeClass(labelIndex)"
              >
                {{ label.badgeText || label.labelName }}
              </span>
            </div>
            <p class="font-semibold text-[#202632] text-[14px] sm:text-[15px] leading-[1.45] min-h-[42px] line-clamp-2">{{ product.title }}</p>
            <div v-if="productSpecText(product)" class="min-h-[34px] text-[11px] sm:text-[12px] font-medium leading-[1.5] text-[#6f7886]">
              <p>{{ productSpecText(product) }}</p>
              <p v-if="purityText(product)">순도 {{ purityText(product) }}</p>
            </div>
            <div class="mt-auto pt-[8px]">
              <p class="font-bold text-[#202632] text-[15px] sm:text-[17px] leading-[1.35]">{{ product.price }}</p>
              <p v-if="product.originalPrice" class="text-[#8a8f99] text-[13px] line-through">{{ product.originalPrice }}</p>
            </div>
            <div class="flex items-center justify-end pt-[4px]">
              <button
                type="button"
                class="inline-flex h-[34px] items-center justify-center gap-[6px] rounded-full px-[8px] text-[12px] font-bold text-[#0072ce] transition-colors hover:bg-[#eef6ff] sm:h-[36px] sm:gap-[7px] sm:px-[12px] sm:text-[14px]"
                @click.stop="addToCart(product)"
              >
                <span class="flex size-[20px] items-center justify-center rounded-full bg-[#0072ce] text-[16px] leading-none text-white">+</span>
                <span>{{ product.priceDisplayType === 'CONTACT' ? '가격문의' : '장바구니 추가' }}</span>
              </button>
            </div>
          </div>
          </div>
        </div>
        <button
          v-if="mainProducts.length > 4"
          type="button"
          class="carousel-nav carousel-nav--right"
          aria-label="다음 주요브렌드 보기"
          @click="scrollProductRow('mainProductsScroller', 1)"
        >
          ›
        </button>
      </div>
      <div v-else-if="mainDisplayLoaded" class="w-full rounded-[8px] border border-[#e5e9ed] bg-white py-[48px] text-center text-[#727c8d]">
        현재 노출 중인 주요브렌드가 없습니다.
      </div>
    </div>

    <!-- 9. Page disclaimer #2 - 5 product grid (coins) -->
    <div class="home-sky-gradient-start flex flex-col items-center py-[32px] sm:py-[70px] w-full">
      <div class="flex flex-col gap-[18px] sm:gap-[32px] items-start max-w-[1240px] w-full px-[16px] lg:px-0">
      <div class="flex items-center justify-between w-full whitespace-nowrap">
        <p class="font-bold text-[#202632] text-[16px] sm:text-[24px]">오늘의 추천 상품</p>
        <router-link to="/products" class="text-[#3a4250] text-[12px] sm:text-[14px] hover:text-[#3e6fb3] transition-colors">상품 전체보기 →</router-link>
      </div>
      <div v-if="brandTabs.length" class="flex w-full gap-[18px] overflow-x-auto border-b border-[#d9dee7] pb-[8px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:gap-[22px]">
        <button
          v-for="brand in brandTabs"
          :key="brand.brandCode"
          type="button"
          class="shrink-0 border-b-2 pb-[7px] text-[14px] font-semibold transition-colors sm:text-[15px]"
          :class="activeBrandCode === brand.brandCode ? 'border-[#0072ce] text-[#0072ce]' : 'border-transparent text-[#00284a] hover:text-[#0072ce]'"
          @click="selectBrandTab(brand.brandCode)"
        >
          {{ brand.brandName }}
        </button>
      </div>
      <div v-if="mainDisplayLoaded && coinProducts.length" class="relative w-full">
        <button
          v-if="coinProducts.length > 4"
          type="button"
          class="carousel-nav carousel-nav--left"
          aria-label="이전 추천 상품 보기"
          @click="scrollProductRow('coinProductsScroller', -1)"
        >
          ‹
        </button>
        <div ref="coinProductsScroller" class="product-carousel-row">
          <div
            v-for="(coin, idx) in coinProducts"
            :key="idx"
            class="mall-product-card product-carousel-card relative overflow-hidden flex flex-col cursor-pointer"
          role="link"
          tabindex="0"
          @click="goDisplayProduct(coin)"
          @keydown.enter.prevent="goDisplayProduct(coin)"
        >
          <span v-if="coin.discountRateText" class="discount-badge">
            <span class="discount-badge__rate">{{ coin.discountRateText }}</span>
          </span>
          <div class="relative h-[178px] sm:h-[260px] bg-[#f8f9fb] flex items-center justify-center p-[14px] sm:p-[20px] shrink-0 w-full">
            <img v-if="coin.image" :src="coin.image" :alt="coin.title" class="w-full h-full object-contain" />
            <div v-else class="w-[120px] h-[120px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[#8a8f99] text-[12px]">
              이미지 없음
            </div>
          </div>
          <div class="p-[12px] sm:p-[16px] flex flex-col gap-[8px] sm:gap-[10px] grow w-full">
            <div v-if="coin.labels.length" class="flex min-h-[26px] flex-wrap items-center gap-[6px]">
              <span
                v-for="(label, labelIndex) in coin.labels"
                :key="label.productLabelCode"
                class="product-label-badge"
                :class="labelBadgeClass(labelIndex)"
              >
                {{ label.badgeText || label.labelName }}
              </span>
            </div>
            <p class="font-semibold text-[#202632] text-[14px] sm:text-[15px] leading-[1.45] min-h-[42px] line-clamp-2">{{ coin.title }}</p>
            <div v-if="productSpecText(coin)" class="min-h-[34px] text-[11px] sm:text-[12px] font-medium leading-[1.5] text-[#6f7886]">
              <p>{{ productSpecText(coin) }}</p>
              <p v-if="purityText(coin)">순도 {{ purityText(coin) }}</p>
            </div>
            <div class="mt-auto pt-[8px]">
              <p class="font-bold text-[#202632] text-[15px] sm:text-[17px] leading-[1.35]">{{ coin.price }}</p>
              <p v-if="coin.originalPrice" class="text-[#8a8f99] text-[13px] line-through">{{ coin.originalPrice }}</p>
            </div>
            <div class="flex items-center justify-end pt-[4px]">
              <button
                type="button"
                class="inline-flex h-[34px] items-center justify-center gap-[6px] rounded-full px-[8px] text-[12px] font-bold text-[#0072ce] transition-colors hover:bg-[#eef6ff] sm:h-[36px] sm:gap-[7px] sm:px-[12px] sm:text-[14px]"
                @click.stop="addToCart(coin)"
              >
                <span class="flex size-[20px] items-center justify-center rounded-full bg-[#0072ce] text-[16px] leading-none text-white">+</span>
                <span>{{ coin.priceDisplayType === 'CONTACT' ? '가격문의' : '장바구니 추가' }}</span>
              </button>
            </div>
          </div>
          </div>
        </div>
        <button
          v-if="coinProducts.length > 4"
          type="button"
          class="carousel-nav carousel-nav--right"
          aria-label="다음 추천 상품 보기"
          @click="scrollProductRow('coinProductsScroller', 1)"
        >
          ›
        </button>
      </div>
      <div v-else-if="mainDisplayLoaded" class="w-full rounded-[8px] border border-[#e5e9ed] bg-white py-[48px] text-center text-[#727c8d]">
        현재 노출 중인 추천 상품이 없습니다.
      </div>
      </div>
    </div>

    <!-- 10-12. Continuous sky-gradient band: market comparison → secure wealth → certified brands -->
    <div class="home-sky-gradient-combined w-full">
    <!-- 10. Long-term market comparison chart -->
    <div class="flex justify-center py-[44px] sm:py-[86px] lg:py-[108px] w-full">
      <div class="flex flex-col lg:flex-row gap-[24px] lg:gap-[54px] items-start max-w-[1240px] w-full px-[16px] lg:px-0">
        <div class="flex flex-1 flex-col gap-[16px] items-start text-[#202632] w-full">
          <div class="font-bold text-[20px] sm:text-[24px] leading-tight">
            <p>오늘의 금·은 시세를</p>
            <p class="text-[#3e6fb3]">10년전과 비교해보세요.</p>
<!--            <p class="text-[#3e6fb3]">비교해보세요</p>-->
          </div>
          <div class="text-[13px] sm:text-[16px] leading-relaxed text-[#3a4250] w-full">
            <p>해외 시세는 USD/oz 가격과 원·달러 환율을 반영해 원화로 환산합니다.</p>
            <p>1돈 또는 1g 기준으로 국내 시세와 국제 시세의 흐름을 함께 확인해보세요.</p>
          </div>
          <div class="flex flex-wrap gap-x-[14px] gap-y-[8px] pt-[8px] text-[12px] sm:text-[13px] text-[#727c8d]">
            <div class="flex items-center gap-[6px]"><span class="h-[3px] w-[24px] rounded-full" style="background: repeating-linear-gradient(90deg, #202632 0 5px, transparent 5px 9px);"></span><span>국내 시세 차트</span></div>
            <div class="flex items-center gap-[6px]"><span class="h-[3px] w-[24px] rounded-full bg-[#1388ff]"></span><span>해외 환산 시세 차트</span></div>
          </div>
        </div>

        <div class="flex flex-col gap-[14px] sm:gap-[18px] shrink-0 w-full lg:w-[680px]">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-[8px] sm:gap-[10px]">
            <div class="market-toggle-group bg-white grid grid-cols-2 gap-[6px] items-center p-[4px] rounded-[10px] shadow-sm w-full sm:flex sm:w-auto">
              <button v-for="metal in marketMetals" :key="metal.value" type="button" class="flex items-center justify-center px-[12px] sm:px-[14px] py-[5px] sm:py-[4px] rounded-[8px] min-w-0 sm:min-w-[64px]" :class="activeMetal === metal.value ? 'bg-[#3e6fb3] text-white' : 'text-[#727c8d]'" @click="setActiveMetal(metal.value)">
                <span class="font-semibold text-[13px] sm:text-[14px]">{{ metal.label }}</span>
              </button>
            </div>
            <div class="grid grid-cols-[0.9fr_1.8fr] gap-[8px] sm:flex sm:flex-wrap">
              <div class="bg-white grid grid-cols-2 gap-[6px] items-center p-[4px] rounded-[10px] shadow-sm">
                <button v-for="unit in weightUnits" :key="unit.value" type="button" class="flex items-center justify-center px-[8px] sm:px-[12px] py-[5px] sm:py-[4px] rounded-[8px] min-w-0 sm:min-w-[56px]" :class="activeWeightUnit === unit.value ? 'bg-[#3e6fb3] text-white' : 'text-[#727c8d]'" @click="setActiveWeightUnit(unit.value)">
                  <span class="font-semibold text-[13px] sm:text-[14px]">{{ unit.label }}</span>
                </button>
              </div>
              <div class="bg-white grid grid-cols-4 gap-[4px] items-center p-[4px] rounded-[10px] shadow-sm">
                <button v-for="range in longDateRanges" :key="range.value" type="button" class="flex items-center justify-center px-[6px] sm:px-[12px] py-[5px] sm:py-[4px] rounded-[8px] min-w-0 sm:min-w-[58px]" :class="activeDateRange === range.value ? 'bg-[#3e6fb3] text-white' : 'text-[#727c8d]'" @click="setActiveDateRange(range.value)">
                  <span class="font-semibold text-[13px] sm:text-[14px] whitespace-nowrap">{{ range.label }}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="rounded-[12px] bg-white border border-[#e1e6ee] p-[16px] sm:p-[22px] shadow-sm">
            <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-[8px] pb-[12px] sm:pb-[14px]">
              <div>
                <p class="text-[12px] sm:text-[13px] text-[#727c8d]">{{ activeMetalLabel }} 시세 비교 · {{ activeWeightUnitLabel }} 기준</p>
                <p class="text-[22px] sm:text-[28px] font-semibold leading-tight text-[#202632]">{{ formatWon(longMarketLatestPrice) }}</p>
              </div>
              <div class="text-[11px] sm:text-[13px] leading-relaxed text-[#727c8d] sm:text-right">
                <p>최근 기준일 {{ longMarketLatestDate || '-' }}</p>
                <p>Y축: 금액 · X축: 기간</p>
              </div>
            </div>

            <div class="relative h-[270px] sm:h-[280px] w-full">
              <svg
                :viewBox="longMarketSvgViewBox"
                class="h-full w-full cursor-crosshair"
                xmlns="http://www.w3.org/2000/svg"
                @mousemove="handleLongMarketMouseMove"
                @mouseleave="clearLongMarketHover"
              >
                <defs>
                  <linearGradient id="domesticMarketFill" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stop-color="#202632" stop-opacity="0.2"/>
                    <stop offset="100%" stop-color="#202632" stop-opacity="0"/>
                  </linearGradient>
                  <linearGradient id="globalMarketFill" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stop-color="#1f8cff" stop-opacity="0.34"/>
                    <stop offset="100%" stop-color="#1f8cff" stop-opacity="0.02"/>
                  </linearGradient>
                </defs>

                <g v-for="tick in longMarketYAxisTicks" :key="tick.label">
                  <line :x1="longMarketChartBox.left" :y1="tick.y" :x2="longMarketChartBox.right" :y2="tick.y" stroke="#d6e2ec" stroke-width="1" stroke-dasharray="4 5"/>
                  <text x="4" :y="tick.y + 4" fill="#7f92a8" :font-size="longMarketAxisFontSize" font-weight="500">{{ tick.label }}</text>
                </g>

                <path v-if="globalAreaPath" :d="globalAreaPath" fill="url(#globalMarketFill)"/>
                <path v-if="domesticAreaPath" :d="domesticAreaPath" fill="url(#domesticMarketFill)"/>
                <path v-if="globalLinePath" :d="globalLinePath" fill="none" stroke="#1388ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path v-if="domesticLinePath" :d="domesticLinePath" fill="none" stroke="#202632" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="6 5"/>

                <g v-if="longMarketActivePoint">
                  <line :x1="longMarketActivePoint.x" :y1="longMarketChartBox.top" :x2="longMarketActivePoint.x" :y2="longMarketChartBox.bottom" stroke="#7f92a8" stroke-width="1" stroke-dasharray="5 5"/>
                  <circle v-if="Number.isFinite(longMarketActivePoint.globalY)" :cx="longMarketActivePoint.x" :cy="longMarketActivePoint.globalY" r="4" fill="#ffffff" stroke="#1388ff" stroke-width="1.6"/>
                  <circle v-if="Number.isFinite(longMarketActivePoint.domesticY)" :cx="longMarketActivePoint.x" :cy="longMarketActivePoint.domesticY" r="4" fill="#ffffff" stroke="#202632" stroke-width="1.6"/>
                </g>

                <g v-for="tick in longMarketXAxisTicks" :key="tick.label">
                  <text :x="tick.x" :y="longMarketChartBox.height - 8" text-anchor="middle" fill="#7f92a8" :font-size="longMarketAxisFontSize" font-weight="500">{{ tick.label }}</text>
                </g>

                <g v-if="longMarketTooltipPoint">
                  <rect :x="longMarketTooltipPoint.boxX" :y="longMarketTooltipPoint.boxY" :width="longMarketTooltipPoint.boxWidth" :height="longMarketTooltipPoint.boxHeight" rx="8" fill="#ffffff" filter="drop-shadow(0 8px 18px rgba(0, 38, 77, 0.12))"/>
                  <text :x="longMarketTooltipPoint.boxX + 12" :y="longMarketTooltipPoint.boxY + 21" fill="#7f92a8" :font-size="longMarketTooltipDateFontSize" font-weight="600">{{ longMarketTooltipPoint.monthLabel }}</text>
                  <g v-for="(series, index) in longMarketTooltipPoint.series" :key="series.key">
                    <circle :cx="longMarketTooltipPoint.boxX + 15" :cy="longMarketTooltipPoint.boxY + 41 + index * 19" r="3.2" :fill="series.color"/>
                    <text :x="longMarketTooltipPoint.boxX + 24" :y="longMarketTooltipPoint.boxY + 45 + index * 19" :fill="series.color" :font-size="longMarketTooltipValueFontSize" font-weight="800">{{ series.label }} {{ series.text }}</text>
                  </g>
                </g>
              </svg>
              <div v-if="!longMarketChartPoints.length && !marketPriceLoading" class="absolute inset-0 flex items-center justify-center text-[14px] text-[#727c8d]">장기 시세 데이터가 없습니다.</div>
            </div>

            <div class="grid grid-cols-4 gap-[6px] sm:gap-[12px] pt-[12px] sm:pt-[16px] border-t border-[#edf1f6] text-center">
              <div><p class="text-[11px] sm:text-[12px] text-[#727c8d]">시작가</p><p class="text-[13px] sm:text-[16px] font-semibold text-[#3a4250]">{{ formatNumber(longMarketSummary.open) }}</p></div>
              <div><p class="text-[11px] sm:text-[12px] text-[#727c8d]">고가</p><p class="text-[13px] sm:text-[16px] font-semibold text-[#3a4250]">{{ formatNumber(longMarketSummary.high) }}</p></div>
              <div><p class="text-[11px] sm:text-[12px] text-[#727c8d]">저가</p><p class="text-[13px] sm:text-[16px] font-semibold text-[#3a4250]">{{ formatNumber(longMarketSummary.low) }}</p></div>
              <div><p class="text-[11px] sm:text-[12px] text-[#727c8d]">종가</p><p class="text-[13px] sm:text-[16px] font-semibold text-[#3a4250]">{{ formatNumber(longMarketSummary.close) }}</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 11. Page disclaimer #4 - partner logos -->
    <div class="hidden">
      <div class="flex flex-col gap-[24px] sm:gap-[50px] items-start max-w-[1240px] w-full">
      <div class="flex gap-[10px] items-end justify-center w-full px-[16px]">
        <p class="font-bold text-[#202632] text-[24px] sm:text-[36px] whitespace-nowrap">제휴 파트너사</p>
      </div>
      <div class="marquee-wrapper relative w-full overflow-hidden">
        <div class="flex gap-[32px] sm:gap-[64px] items-center marquee-track py-[4px]">
          <div v-for="(logo, idx) in partnerLogos" :key="'a' + idx" class="h-[90px] w-[180px] flex items-center justify-center shrink-0">
            <img :src="logo" alt="제휴 파트너사 로고" class="max-h-full max-w-full object-contain" />
          </div>
          <div v-for="(logo, idx) in partnerLogos" :key="'b' + idx" class="h-[90px] w-[180px] flex items-center justify-center shrink-0">
            <img :src="logo" alt="제휴 파트너사 로고" class="max-h-full max-w-full object-contain" />
          </div>
        </div>
      </div>
      </div>
    </div>

    <!-- 11-1. Secure your wealth -->
    <div class="flex justify-center py-[48px] sm:py-[76px] lg:py-[96px] w-full">
      <div class="flex flex-col gap-[22px] sm:gap-[36px] items-start max-w-[1240px] w-full px-[16px] lg:px-0">
        <div class="flex gap-[16px] items-center justify-between w-full">
          <div class="flex flex-col gap-[10px] sm:gap-[14px] items-start">
            <p class="font-bold text-[#202632] text-[16px] sm:text-[24px] whitespace-nowrap">자산을 안전하게 지키세요</p>
            <p class="text-[#3a4250] text-[14px] sm:text-[17px] leading-relaxed w-full">
              <span class="font-semibold">금, 은, 백금,</span> <span class="font-semibold">팔라듐</span> 실물 자산을 구매하고 어디서든 나만의 귀금속 포트폴리오를 만들어보세요.
            </p>
          </div>
          <img :src="auraGoldbar" alt="AURA 골드바" class="block shrink-0 w-[70px] sm:w-[110px] lg:w-[150px] object-contain -rotate-6" />
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-[16px] sm:gap-[24px] w-full">
          <div v-for="(feature, idx) in secureWealthFeatures" :key="idx" class="bg-white flex flex-col gap-[16px] items-start border border-[#edf1f6] rounded-[8px] p-[24px] sm:p-[28px] w-full transition-shadow duration-200 hover:shadow-[0_8px_24px_rgba(32,38,50,0.12)]">
            <p class="font-bold text-[#202632] text-[18px] sm:text-[22px] leading-snug whitespace-pre-line">{{ feature.title }}</p>
            <p class="text-[#3a4250] text-[14px] sm:text-[15px] leading-relaxed">{{ feature.description }}</p>
            <div class="flex-1"></div>
            <a v-if="feature.linkText" href="javascript:void(0)" class="text-[#1388ff] text-[14px] sm:text-[15px] font-medium">{{ feature.linkText }} →</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 12. Page disclaimer #5 - 인증 브랜드 -->
    <div class="flex justify-center py-[48px] sm:py-[76px] lg:py-[96px] w-full">
      <div class="flex flex-col gap-[22px] sm:gap-[36px] items-start max-w-[1240px] w-full px-[16px] lg:px-0">
      <div class="flex gap-[10px] items-center justify-start w-full">
        <p class="font-bold text-[#202632] text-[16px] sm:text-[24px] whitespace-nowrap">공식 인증 및 취급 브랜드</p>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-[16px] sm:gap-x-[24px] gap-y-[34px] sm:gap-y-[44px] w-full">
        <component
          :is="brand.url ? 'a' : 'div'"
          v-for="(brand, idx) in certifiedBrands"
          :key="idx"
          :href="brand.url || undefined"
          :target="brand.url ? '_blank' : undefined"
          :rel="brand.url ? 'noopener noreferrer' : undefined"
          class="bg-white flex flex-col items-start overflow-hidden rounded-[4px] w-full"
        >
          <div class="h-[140px] sm:h-[176px] w-full flex items-center justify-center" :style="{ backgroundColor: brand.color }">
            <img :src="brand.image" :alt="brand.shortName" class="max-h-[86px] sm:max-h-[104px] max-w-[180px] sm:max-w-[220px] object-contain" />
          </div>
          <div class="flex flex-col gap-[8px] items-start overflow-hidden py-[14px] sm:py-[18px] w-full">
            <p class="font-semibold text-[#3e6fb3] text-[14px] sm:text-[15px] w-full">{{ brand.category }}</p>
            <p class="font-bold text-[#3a4250] text-[17px] sm:text-[20px] w-full">{{ brand.title }}</p>
            <p class="text-[#3a4250] text-[14px] sm:text-[15px] leading-relaxed w-full">{{ brand.description }}</p>
          </div>
        </component>
      </div>
      </div>
    </div>
    </div>

    <!-- 13. Page disclaimer #6 - 거래 안내 steps -->
    <div class="bg-white flex flex-col items-center pb-[52px] sm:pb-[84px] lg:pb-[110px] pt-[36px] sm:pt-[56px] w-full">
      <div class="flex flex-col gap-[24px] sm:gap-[36px] items-start max-w-[1240px] w-full px-[16px] lg:px-0">
      <div class="flex gap-[10px] items-center justify-start w-full">
        <p class="font-bold text-[#202632] text-[16px] sm:text-[24px] whitespace-nowrap">거래 안내</p>
      </div>
      <div class="flex flex-wrap items-start justify-center gap-y-[32px] w-full">
        <template v-for="(step, idx) in tradeSteps" :key="step.title">
          <div class="flex flex-col gap-[8px] items-center basis-1/3 sm:basis-1/4 lg:basis-0 lg:flex-1 px-[8px]">
            <div
              class="bg-white border-[#ddd] border border-solid flex flex-col items-center justify-center overflow-hidden rounded-full shrink-0 size-[80px] sm:size-[110px] lg:size-[140px] [&_svg]:size-[44px] sm:[&_svg]:size-[60px] lg:[&_svg]:size-[80px]"
              v-html="step.icon"
            ></div>
            <div class="flex flex-col items-start text-[#3a4250] text-center w-full">
              <p class="text-[12px] sm:text-[15px] w-full">{{ step.num }}</p>
              <p class="font-semibold text-[13px] sm:text-[16px] lg:text-[18px] w-full" v-html="step.title"></p>
            </div>
          </div>
          <div v-if="idx < tradeSteps.length - 1" class="hidden lg:flex h-[140px] w-[32px] items-center justify-center shrink-0">
            <span class="text-[#d7d7d7] text-[24px]">→</span>
          </div>
        </template>
      </div>
      <div class="flex flex-wrap gap-[10px] sm:gap-[18px] items-center justify-center w-full">
        <p class="text-[#3a4250] text-[12px] sm:text-[14px] whitespace-nowrap">보관서비스 안내</p>
        <div class="bg-[#b8bec8] h-[16px] w-px shrink-0"></div>
        <p class="text-[#3a4250] text-[12px] sm:text-[14px] whitespace-nowrap">위탁거래 절차</p>
        <div class="bg-[#b8bec8] h-[16px] w-px shrink-0"></div>
        <p class="text-[#3a4250] text-[12px] sm:text-[14px] whitespace-nowrap">배송 안내</p>
      </div>
      </div>
    </div>

    <!-- 15. 금TALK FAQ -->
    <div class="bg-white flex justify-center py-[40px] sm:py-[70px] w-full">
      <div class="flex flex-col gap-[18px] sm:gap-[24px] items-start max-w-[1240px] w-full px-[16px] lg:px-0">
      <div class="flex items-end justify-start w-full">
        <p class="font-bold text-[#202632] text-[16px] sm:text-[24px] whitespace-nowrap">자주 묻는 질문</p>
      </div>
      <div class="flex flex-col gap-[10px] sm:gap-[14px] items-start overflow-hidden w-full">
        <div
          v-for="(faq, idx) in faqs"
          :key="idx"
          class="flex flex-col items-start overflow-hidden rounded-[10px] w-full"
          :class="faq.open ? 'bg-[#fcfcfc]' : ''"
        >
          <button
            type="button"
            class="bg-[#f7f7f7] flex items-center justify-between gap-[12px] overflow-hidden px-[18px] sm:px-[30px] py-[13px] sm:py-[18px] rounded-[10px] w-full text-left"
            @click="faq.open = !faq.open"
          >
            <p class="font-semibold text-[#3a4250] text-[14px] sm:text-[16px]">{{ faq.question }}</p>
            <span class="text-[#3a4250] text-[14px] shrink-0" :class="faq.open ? 'rotate-180' : ''">⌄</span>
          </button>
          <div
            v-if="faq.open && faq.answer"
            class="border-[#f7f7f7] border-solid border-t flex items-center overflow-hidden px-[18px] sm:px-[30px] py-[13px] sm:py-[18px] w-full"
          >
            <p class="text-[#3a4250] text-[12px] sm:text-[14px] leading-relaxed">{{ faq.answer }}</p>
          </div>
        </div>
      </div>
      </div>
    </div>

    <!-- Partner logos -->
    <div class="bg-white flex justify-center pb-[36px] sm:pb-[56px] pt-[8px] w-full">
      <div class="flex flex-col gap-[18px] items-start max-w-[1240px] w-full px-[16px] lg:px-0">
        <p class="font-bold text-[#202632] text-[16px] sm:text-[24px] whitespace-nowrap">제휴 파트너사</p>
        <div class="marquee-wrapper relative w-full overflow-hidden">
          <div class="marquee-track py-[2px]">
            <div class="partner-marquee-segment">
              <div v-for="(logo, idx) in partnerLogos" :key="'partner-a' + idx" class="h-[30px] w-[60px] sm:h-[34px] sm:w-[68px] flex items-center justify-center shrink-0">
                <img :src="logo" alt="제휴 파트너사 로고" class="max-h-full max-w-full object-contain" />
              </div>
            </div>
            <div class="partner-marquee-segment" aria-hidden="true">
              <div v-for="(logo, idx) in partnerLogos" :key="'partner-b' + idx" class="h-[30px] w-[60px] sm:h-[34px] sm:w-[68px] flex items-center justify-center shrink-0">
                <img :src="logo" alt="" class="max-h-full max-w-full object-contain" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import partnerLogo0 from '@/assets/img/banner/logo.png'
import partnerLogo1 from '@/assets/img/banner/logo-1.png'
import partnerLogo2 from '@/assets/img/banner/logo-2.png'
import partnerLogo3 from '@/assets/img/banner/logo-3.png'
import partnerLogo4 from '@/assets/img/banner/logo-4.png'
import partnerLogo5 from '@/assets/img/banner/logo-5.png'
import auraGoldbar from '@/assets/img/main/aura_goldbar.png'
import lbmaLogo from '@/assets/img/main/lbma.png'
import asiLogo from '@/assets/img/main/asi.png'
import sgsLogo from '@/assets/img/main/sgs.png'
import isoLogo from '@/assets/img/main/iso.png'
import hriLogo from '@/assets/img/main/Hallmark.png'
import certifiKorLogo from '@/assets/img/main/certifi_kor.png'
import promotion01 from '@/assets/img/main/promotion_01.png'
import promotion02 from '@/assets/img/main/promotion_02.png'
import promotion03 from '@/assets/img/main/promotion_03.png'
import mainProduct01 from '@/assets/figma/main/main-product-01.png'
import mainProduct02 from '@/assets/figma/main/main-product-02.png'
import mainProduct03 from '@/assets/figma/main/main-product-03.png'
import mainProduct04 from '@/assets/figma/main/main-product-04.png'
import coinProduct01 from '@/assets/figma/main/coin-product-01.png'
import coinProduct02 from '@/assets/figma/main/coin-product-02.png'
import coinProduct03 from '@/assets/figma/main/coin-product-03.png'
import coinProduct04 from '@/assets/figma/main/coin-product-04.png'
import { getMainDisplay } from '@/api/mainDisplay.js'
import { getMarketPriceLongHistory } from '@/api/marketPrices.js'
import { getProductBrands, getProductLabels, getProducts } from '@/api/products.js'
import { useAuthStore } from '@/stores/auth.js'
import { useCartStore } from '@/stores/cart.js'

export default {
  name: 'HomeView',
  components: { AppHeader, AppFooter },
  setup() {
    return {
      authStore: useAuthStore(),
      cartStore: useCartStore(),
    }
  },
  data() {
      return {
      mobileMenuOpen: false,
      heroBanners: [],
      mainDisplayLoaded: false,
      productLabelTabs: [],
      activeProductLabelKey: '',
      brandTabs: [],
      activeBrandCode: '',
      transactionAmount: 0,
      visitorCount: 0,
      branchPartnerCount: 0,
      activeHeroDot: 0,
      heroTimer: null,
      activeMetal: 'gold',
      activeDateRange: '10y',
      activeWeightUnit: 'DON',
      longMarketPoints: [],
      longMarketHoverIndex: null,
      isMobileMarketChart: false,
      marketPriceLoading: false,
      marketMetals: [
        { value: 'gold', label: '골드' },
        { value: 'silver', label: '실버' },
      ],
      weightUnits: [
        { value: 'DON', label: '1돈' },
        { value: 'G', label: '1g' },
      ],
      longDateRanges: [
        { value: '1y', label: '1년' },
        { value: '3y', label: '3년' },
        { value: '5y', label: '5년' },
        { value: '10y', label: '10년' },
      ],
      mainProducts: [
        {
          image: mainProduct01,
          title: '골드나라 아우라 골드바 1000g',
          price: '237,834,000원',
          originalPrice: '250,352,000원',
          discount: 5,
          tags: ['SALE', 'BEST', 'MD'],
        },
        {
          image: mainProduct02,
          title: '[신형] LS - MNM 골드바 1,000g',
          price: '237,834,000원',
          originalPrice: '250,352,000원',
          discount: 5,
          tags: ['SALE', 'BEST'],
        },
        {
          image: mainProduct03,
          title: '골드나라 아우라 골드바 100g',
          price: '23,830,000원',
          originalPrice: '25,084,000원',
          discount: 5,
          tags: ['SALE', 'BEST'],
        },
        {
          image: mainProduct04,
          title: '골드나라 아우라 골드바 37.5g',
          price: '9,056,000원',
          originalPrice: '9,533,000원',
          discount: 5,
          tags: ['SALE', 'BEST'],
        },
        {
          image: mainProduct01,
          title: '골드나라 아우라 골드바 1000g',
          price: '237,834,000원',
          originalPrice: '250,352,000원',
          discount: 5,
          tags: ['SALE', 'BEST', 'MD'],
        },
        {
          image: mainProduct02,
          title: '[신형] LS - MNM 골드바 1,000g',
          price: '237,834,000원',
          originalPrice: '250,352,000원',
          discount: 5,
          tags: ['SALE', 'BEST'],
        },
        {
          image: mainProduct03,
          title: '골드나라 아우라 골드바 100g',
          price: '23,830,000원',
          originalPrice: '25,084,000원',
          discount: 5,
          tags: ['SALE', 'BEST'],
        },
        {
          image: mainProduct04,
          title: '골드나라 아우라 골드바 37.5g',
          price: '9,056,000원',
          originalPrice: '9,533,000원',
          discount: 5,
          tags: ['SALE', 'BEST'],
        },
      ],
      coinProducts: [
        {
          image: coinProduct01,
          title: '2020년 한국조폐공사 실버 봉황 메달 1oz*1 + 2021년 한...',
          price: '350,000원',
          originalPrice: '',
          discount: null,
          tags: [],
        },
        {
          image: coinProduct02,
          title: '2005년 UNITED STATES MINT 실버 프루프 은화 Set',
          price: '900,000원',
          originalPrice: '',
          discount: null,
          tags: [],
        },
        {
          image: coinProduct03,
          title: '1988년 제24회 서울올림픽대회 기념주화 세트 (4차)',
          price: '4,700,000원',
          originalPrice: '',
          discount: null,
          tags: [],
        },
        {
          image: coinProduct04,
          title: '988년 제24회 서울올림픽 기념 서울 컵 세트',
          price: '37,633,000원',
          originalPrice: '56,450,000원',
          discount: 33,
          tags: [],
        },
      ],
      auraGoldbar,
      partnerLogos: [partnerLogo0, partnerLogo1, partnerLogo2, partnerLogo3, partnerLogo4, partnerLogo5],
      secureWealthFeatures: [
        {
          title: '구매\n실물 귀금속 구매하기',
          description: '엄선된 실물 골드바를 세계적으로 공인된 조폐국과 정련소로부터 직접 만나보세요.',
          linkText: '쇼핑몰 둘러보기',
        },
        {
          title: '보관\n무료로 부담 없이 보관하기',
          description: '장바구니에서 무료 보관 서비스를 선택하기만 하면, 안전한 스위스 보관소에서 상품을 보관해드립니다. 언제든지 재판매하거나 배송받을 수 있습니다.',
          linkText: '보관 서비스 안내',
        },
        {
          title: '재판매\n수수료 0%로 재판매하기',
          description: '24시간 언제든지 수수료 없이 소중한 귀금속을 손쉽게 관리하고 재판매하세요. 필요할 때 언제든 대금을 받으실 수 있습니다.',
          linkText: '간편한 계정 이용 안내',
        },
      ],
      certifiedBrands: [
        {
          color: '#19b3ba',
          image: lbmaLogo,
          url: 'https://www.lbma.org.uk',
          shortName: 'LBMA',
          category: '글로벌 인증 기준',
          title: '국내 최초 LBMA 공인 검사기관',
          description: '런던금시장협회가 운영하는 Good Delivery 기준을 바탕으로 금·은 제품의 품질과 거래 신뢰성을 검증합니다.',
        },
        {
          color: '#ebebec',
          image: asiLogo,
          url: 'https://alexstewartinternational.com',
          shortName: 'ASI',
          category: '글로벌 검사·분석 기관',
          title: 'Alex Stewart International 인증',
          description: '금속·광물·귀금속 분야의 분석, 샘플링, 검사 서비스를 제공하는 글로벌 전문 기관입니다.',
        },
        {
          color: '#f60',
          image: sgsLogo,
          url: 'https://www.sgs.com/ko-kr',
          shortName: 'SGS',
          category: '글로벌 시험·검사·인증 기관',
          title: 'SGS 인증',
          description: '제품의 품질, 안전성, 규정 준수 여부를 검증하는 글로벌 시험·검사·인증 기관입니다.',
        },
        {
          color: '#006cb7',
          image: isoLogo,
          url: 'https://www.iso.org/home.html',
          shortName: 'ISO',
          category: '글로벌 표준 기준',
          title: '국제 품질·관리 표준',
          description: '품질, 안전, 관리 체계 등 다양한 분야의 국제 표준 기준으로 활용됩니다.',
        },
        {
          color: '#ba9f55',
          image: hriLogo,
          url: 'https://hallmark.or.kr',
          shortName: 'HRI',
          category: '국내 품질 인증',
          title: '국내 귀금속 감정·분석 기관',
          description: '귀금속의 함량, 순도, 품질 검사를 수행하는 국내 감정·분석 전문 기관입니다.',
        },
        {
          color: '#fafafa',
          image: certifiKorLogo,
          shortName: '한국귀금속보석감정원',
          category: '국내 품질 인증',
          title: '국내 귀금속·보석 감정 기관',
          description: '귀금속과 보석 제품의 분석, 감정, 검인 업무를 수행하는 국내 전문 기관입니다.',
        },
      ],
      tradeSteps: [
        {
          num: '01',
          title: '회원가입',
          icon: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M53.3337 19.9998C53.3337 27.3636 47.364 33.3332 40.0003 33.3332C32.6365 33.3332 26.667 27.3636 26.667 19.9998C26.667 12.636 32.6365 6.6665 40.0003 6.6665C47.364 6.6665 53.3337 12.636 53.3337 19.9998Z" fill="#3E6FB3"/><path opacity="0.5" d="M48.2577 73.0695C45.8373 73.2428 43.0983 73.3335 39.9997 73.3335C13.333 73.3335 13.333 66.6178 13.333 58.3335C13.333 50.0492 25.2721 43.3335 39.9997 43.3335C49.6017 43.3335 58.0183 46.1882 62.7137 50.4708C60.993 50.0002 58.5787 50.0002 54.9997 50.0002C49.5 50.0002 46.75 50.0002 45.0417 51.7088C43.333 53.4172 43.333 56.1672 43.333 61.6668C43.333 67.1665 43.333 69.9165 45.0417 71.6248C45.8333 72.4168 46.8487 72.8415 48.2577 73.0695Z" fill="#3E6FB3"/><path fill-rule="evenodd" clip-rule="evenodd" d="M54.9997 73.3333C49.5 73.3333 46.75 73.3333 45.0417 71.6247C43.333 69.9163 43.333 67.1663 43.333 61.6667C43.333 56.167 43.333 53.417 45.0417 51.7087C46.75 50 49.5 50 54.9997 50C60.4993 50 63.2493 50 64.9577 51.7087C66.6663 53.417 66.6663 56.167 66.6663 61.6667C66.6663 67.1663 66.6663 69.9163 64.9577 71.6247C63.2493 73.3333 60.4993 73.3333 54.9997 73.3333ZM56.944 56.4813C56.944 55.4077 56.0737 54.537 54.9997 54.537C53.9257 54.537 53.0553 55.4077 53.0553 56.4813V59.7223H49.8143C48.7407 59.7223 47.87 60.5927 47.87 61.6667C47.87 62.7407 48.7407 63.611 49.8143 63.611H53.0553V66.852C53.0553 67.9257 53.9257 68.7963 54.9997 68.7963C56.0737 68.7963 56.944 67.9257 56.944 66.852V63.611H60.185C61.2587 63.611 62.1293 62.7407 62.1293 61.6667C62.1293 60.5927 61.2587 59.7223 60.185 59.7223H56.944V56.4813Z" fill="#3E6FB3"/></svg>',
        },
        {
          num: '02',
          title: '시세 확인',
          icon: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M62.929 25H50C47.2385 25 45 22.7614 45 20C45 17.2386 47.2385 15 50 15H75C77.7615 15 80 17.2386 80 20V45C80 47.7615 77.7615 50 75 50C72.2385 50 70 47.7615 70 45V32.071L48.5355 53.5355C46.583 55.488 43.417 55.488 41.4645 53.5355L30 42.071L8.53555 63.5355C6.5829 65.488 3.4171 65.488 1.46445 63.5355C-0.48815 61.583 -0.48815 58.417 1.46445 56.4645L26.4645 31.4645C28.4171 29.5119 31.583 29.5119 33.5355 31.4645L45 42.929L62.929 25Z" fill="#3E6FB3"/></svg>',
        },
        {
          num: '03',
          title: '상품 선택',
          icon: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M33.4113 6.6665C30.1898 6.6665 27.5781 9.27817 27.5781 12.4998C27.5781 15.7215 30.1898 18.3332 33.4113 18.3332H46.7447C49.9663 18.3332 52.578 15.7215 52.578 12.4998C52.578 9.27817 49.9663 6.6665 46.7447 6.6665H33.4113Z" fill="#3E6FB3"/><path opacity="0.5" d="M12.9557 54.0172C10.0959 42.5778 8.66596 36.8582 11.6687 33.0124C14.6715 29.1665 20.5672 29.1665 32.3585 29.1665H47.794C59.5857 29.1665 65.4813 29.1665 68.484 33.0124C71.4867 36.8582 70.057 42.5778 67.197 54.0172C65.378 61.2928 64.4687 64.9305 61.756 67.0485C59.0433 69.1665 55.2937 69.1665 47.794 69.1665H32.3585C24.859 69.1665 21.1093 69.1665 18.3967 67.0485C15.684 64.9305 14.7746 61.2928 12.9557 54.0172Z" fill="#3E6FB3"/><path d="M52.0127 15.0082C52.375 14.2485 52.5777 13.3982 52.5777 12.5005C52.5777 11.607 52.377 10.7604 52.018 10.0034C54.2964 10.02 56.072 10.1246 57.6574 10.7441C59.5514 11.4843 61.1987 12.7427 62.411 14.3752C63.634 16.0221 64.2084 18.1331 64.9984 21.0386L65.153 21.6065L66.862 31.4831C65.5 30.5433 63.7434 29.9849 61.471 29.6531L60.2667 22.693C59.321 19.2273 58.9777 18.1382 58.3967 17.3563C57.744 16.4772 56.857 15.7997 55.837 15.4011C55.1044 15.1147 54.219 15.0305 52.0127 15.0082Z" fill="#3E6FB3"/><path d="M28.1377 10.0034C27.7787 10.7604 27.5778 11.607 27.5778 12.5005C27.5778 13.3982 27.7806 14.2485 28.1428 15.0082C25.9366 15.0305 25.0514 15.1147 24.3187 15.4011C23.2989 15.7997 22.4118 16.4772 21.759 17.3563C21.1783 18.1382 20.835 19.2273 19.889 22.693L18.6847 29.6527C16.4129 29.9844 14.6562 30.5425 13.2939 31.4816L15.0027 21.6065L15.1574 21.0386C15.9476 18.1331 16.5218 16.0221 17.7449 14.3752C18.9573 12.7427 20.6046 11.4843 22.4986 10.7441C24.0837 10.1246 25.8594 10.02 28.1377 10.0034Z" fill="#3E6FB3"/></svg>',
        },
        {
          num: '04',
          title: '주문/결제',
          icon: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M33.333 66.6668H46.6664C59.2371 66.6668 65.5224 66.6668 69.4278 62.7615C73.3331 58.8565 73.3331 52.5708 73.3331 40.0002C73.3331 38.5272 73.3274 34.6402 73.3211 33.3335H6.66709C6.66079 34.6402 6.66629 38.5272 6.66629 40.0002C6.66629 52.5708 6.66629 58.8565 10.5715 62.7615C14.4768 66.6668 20.7622 66.6668 33.333 66.6668Z" fill="#3E6FB3"/><path d="M33.3165 13.3335H46.6843C59.2873 13.3335 65.589 13.3335 69.5043 17.0528C72.3233 19.7307 73.1127 23.5837 73.3337 30.0002V33.3335H6.66699V30.0002C6.88799 23.5837 7.67733 19.7307 10.4964 17.0528C14.4117 13.3335 20.7133 13.3335 33.3165 13.3335Z" fill="#3E6FB3"/><path d="M41.667 50.8335C40.2863 50.8335 39.167 51.9528 39.167 53.3335C39.167 54.7142 40.2863 55.8335 41.667 55.8335H46.667C48.0477 55.8335 49.167 54.7142 49.167 53.3335C49.167 51.9528 48.0477 50.8335 46.667 50.8335H41.667Z" fill="#3E6FB3"/><path d="M20 50.8335C18.6193 50.8335 17.5 51.9528 17.5 53.3335C17.5 54.7142 18.6193 55.8335 20 55.8335H33.3333C34.714 55.8335 35.8333 54.7142 35.8333 53.3335C35.8333 51.9528 34.714 50.8335 33.3333 50.8335H20Z" fill="#3E6FB3"/></svg>',
        },
        {
          num: '05',
          title: '배송지 또는<br />지점선택',
          icon: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 77.5C60.7107 77.5 77.5 72.4632 77.5 66.25C77.5 60.0368 60.7107 55 40 55C19.2893 55 2.5 60.0368 2.5 66.25C2.5 72.4632 19.2893 77.5 40 77.5Z" fill="#3E6FB3" fill-opacity="0.5"/><path d="M57.0751 36.125C56.8486 35.7811 56.5407 35.4985 56.1787 35.3022C55.8167 35.1059 55.4118 35.0021 55.0001 35H25.0001C24.5883 35.0021 24.1834 35.1059 23.8214 35.3022C23.4594 35.4985 23.1515 35.7811 22.9251 36.125C22.7011 36.4649 22.5635 36.8544 22.5243 37.2596C22.4851 37.6648 22.5454 38.0734 22.7001 38.45L34.2251 66.15C34.6979 67.2925 35.4989 68.2691 36.5269 68.9562C37.5549 69.6433 38.7636 70.01 40.0001 70.01C41.2365 70.01 42.4452 69.6433 43.4732 68.9562C44.5012 68.2691 45.3022 67.2925 45.7751 66.15L57.3001 38.45C57.4547 38.0734 57.515 37.6648 57.4758 37.2596C57.4366 36.8544 57.299 36.4649 57.0751 36.125Z" fill="#3E6FB3"/><path d="M40 57.5C55.1878 57.5 67.5 45.1878 67.5 30C67.5 14.8122 55.1878 2.5 40 2.5C24.8122 2.5 12.5 14.8122 12.5 30C12.5 45.1878 24.8122 57.5 40 57.5Z" fill="#9AB2D4"/><path d="M40 45C48.2843 45 55 38.2843 55 30C55 21.7157 48.2843 15 40 15C31.7157 15 25 21.7157 25 30C25 38.2843 31.7157 45 40 45Z" fill="#3E6FB3"/></svg>',
        },
        {
          num: '06',
          title: '배송 또는<br />방문 수령',
          icon: '<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6663 3.3335C13.533 3.3335 10.633 4.4335 8.33301 6.26683C5.26634 8.70016 3.33301 12.4668 3.33301 16.6668C3.33301 24.0335 9.29967 30.0002 16.6663 30.0002C20.033 30.0002 23.0997 28.7335 25.4664 26.6668C28.233 24.2335 29.9997 20.6668 29.9997 16.6668C29.9997 9.30016 24.033 3.3335 16.6663 3.3335ZM19.9997 17.5002C19.9997 18.3668 19.533 19.2002 18.7997 19.6335L14.633 22.1335C14.233 22.3669 13.7997 22.5002 13.3664 22.5002C12.533 22.5002 11.6997 22.0669 11.233 21.3002C10.533 20.1002 10.8997 18.5668 12.0997 17.8668L15.0664 16.1002V12.5002C15.0664 11.1335 16.1997 10.0002 17.5664 10.0002C18.9331 10.0002 20.0664 11.1335 20.0664 12.5002V17.5002H19.9997Z" fill="#3E6FB3"/><path d="M50.0003 9.99984V39.9998C50.0003 43.6665 47.0003 46.6665 43.3337 46.6665H6.66699V25.3998C9.10033 28.2998 12.8338 30.0998 16.9671 29.9998C20.3338 29.9332 23.367 28.6332 25.6337 26.4665C26.667 25.5998 27.5337 24.4998 28.2004 23.2998C29.4004 21.2665 30.067 18.8664 30.0003 16.3664C29.9003 12.4664 28.167 9.03317 25.467 6.6665H46.667C48.5003 6.6665 50.0003 8.1665 50.0003 9.99984Z" fill="#3E6FB3" fill-opacity="0.5"/><path d="M73.3337 46.6665V56.6665C73.3337 62.1998 68.867 66.6665 63.3337 66.6665H60.0003C60.0003 62.9998 57.0003 59.9998 53.3337 59.9998C49.667 59.9998 46.667 62.9998 46.667 66.6665H33.3337C33.3337 62.9998 30.3337 59.9998 26.667 59.9998C23.0003 59.9998 20.0003 62.9998 20.0003 66.6665H16.667C11.1337 66.6665 6.66699 62.1998 6.66699 56.6665V46.6665H43.3337C47.0003 46.6665 50.0003 43.6665 50.0003 39.9998V16.6665H56.1337C58.5337 16.6665 60.7337 17.9665 61.9337 20.0332L67.6337 29.9998H63.3337C61.5003 29.9998 60.0003 31.4998 60.0003 33.3332V43.3332C60.0003 45.1665 61.5003 46.6665 63.3337 46.6665H73.3337Z" fill="#3E6FB3"/><path d="M26.6667 73.3333C30.3486 73.3333 33.3333 70.3487 33.3333 66.6667C33.3333 62.9847 30.3486 60 26.6667 60C22.9848 60 20 62.9847 20 66.6667C20 70.3487 22.9848 73.3333 26.6667 73.3333Z" fill="#3E6FB3" fill-opacity="0.5"/><path d="M53.3337 73.3333C57.0157 73.3333 60.0003 70.3487 60.0003 66.6667C60.0003 62.9847 57.0157 60 53.3337 60C49.6517 60 46.667 62.9847 46.667 66.6667C46.667 70.3487 49.6517 73.3333 53.3337 73.3333Z" fill="#3E6FB3" fill-opacity="0.5"/><path d="M73.3333 41.7667V46.6667H63.3333C61.5 46.6667 60 45.1667 60 43.3333V33.3333C60 31.5 61.5 30 63.3333 30H67.6333L72.4667 38.4667C73.0333 39.4667 73.3333 40.6 73.3333 41.7667Z" fill="#3E6FB3" fill-opacity="0.5"/></svg>',
        },
      ],
      promoBanners: [
        { image: promotion01, label: '아우라 골드바 컬렉션 →' },
        { image: promotion02, label: '실버바 컬렉션 →' },
        { image: promotion03, label: '주얼리·24K →' },
      ],
      faqs: [
        { question: '금을 팔때 신분증하고 통장 계좌번호가 있어야 하나요?', answer: '', open: false },
        { question: '통장입금을 한다면 얼마나 시간이 걸리나요?', answer: '고객님이 매장을 나가기 전에 통장송금 확인이 가능합니다.', open: true },
        { question: '정제비, 정련비가 무엇 인가요?', answer: '', open: false },
        { question: '국내 금가격은 어떻게 고시 되나요?', answer: '', open: false },
        { question: '백금과 화이트 골드의 차이점은 무엇인가요?', answer: '', open: false },
        { question: '다이아몬드 감정서를 잃어버렸는데 매입이 가능한가요?', answer: '', open: false },
        { question: '다이아몬드외의 유색 보석도 매입 하나요?', answer: '', open: false },
      ],
    }
  },
  mounted() {
    this.updateMarketChartViewport()
    window.addEventListener('resize', this.updateMarketChartViewport)
    this.animateCounter('transactionAmount', 770000000, 2000)
    this.animateCounter('visitorCount', 55000, 2000)
    this.animateCounter('branchPartnerCount', 50, 2000)
    this.mainProducts = []
    this.coinProducts = []
    this.fetchMainDisplay()
    this.fetchHomeProductSections()
    this.fetchMarketPrices()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateMarketChartViewport)
    this.stopHeroAutoSlide()
  },
  computed: {
    currentHeroBanner() {
      return this.heroBanners[this.activeHeroDot] || this.heroBanners[0] || {
        imageUrl: '',
        title: 'GOLDNARA main banner',
      }
    },
    heroDots() {
      return this.heroBanners.map((_, idx) => idx)
    },
    activeMetalLabel() {
      return this.activeMetal === 'silver' ? '\uC2E4\uBC84' : '\uACE8\uB4DC'
    },
    activeWeightUnitLabel() {
      return this.activeWeightUnit === 'G' ? '1g' : '1\uB3C8(3.75g)'
    },
    longMarketValues() {
      return (this.longMarketPoints || [])
        .flatMap(point => [Number(point.domesticPrice), Number(point.globalKrwPrice)])
        .filter(value => Number.isFinite(value) && value > 0)
    },
    longMarketChartBox() {
      if (this.isMobileMarketChart) {
        return {
          width: 360,
          height: 300,
          left: 48,
          right: 350,
          top: 24,
          bottom: 254,
        }
      }
      return {
        width: 680,
        height: 280,
        left: 76,
        right: 668,
        top: 18,
        bottom: 244,
      }
    },
    longMarketSvgViewBox() {
      const box = this.longMarketChartBox
      return `0 0 ${box.width} ${box.height}`
    },
    longMarketAxisFontSize() {
      return this.isMobileMarketChart ? 10 : 12
    },
    longMarketTooltipDateFontSize() {
      return this.isMobileMarketChart ? 10 : 11
    },
    longMarketTooltipValueFontSize() {
      return this.isMobileMarketChart ? 10.5 : 13
    },
    longMarketTooltipWidth() {
      return this.isMobileMarketChart ? 138 : 184
    },
    longMarketScale() {
      const values = this.longMarketValues
      if (!values.length) return { min: 0, max: 1, spread: 1 }
      const rawMin = Math.min(...values)
      const rawMax = Math.max(...values)
      const spread = rawMax - rawMin || Math.max(rawMax, 1)
      const min = Math.max(0, rawMin - spread * 0.08)
      const max = rawMax + spread * 0.08
      return { min, max, spread: max - min || 1 }
    },
    longMarketChartPoints() {
      const rows = this.longMarketPoints || []
      const values = this.longMarketValues
      if (!rows.length || !values.length) return []

      const box = this.longMarketChartBox
      const scale = this.longMarketScale
      const chartWidth = box.right - box.left
      const chartHeight = box.bottom - box.top
      const denominator = Math.max(rows.length - 1, 1)

      return rows.map((row, index) => {
        const x = rows.length === 1 ? box.left + chartWidth / 2 : box.left + (chartWidth / denominator) * index
        const normalizePrice = value => {
          const number = Number(value)
          return Number.isFinite(number) && number > 0 ? number : null
        }
        const toY = value => {
          const number = normalizePrice(value)
          return Number.isFinite(number) ? box.top + ((scale.max - number) / scale.spread) * chartHeight : null
        }
        const domesticPrice = normalizePrice(row.domesticPrice)
        const globalPrice = normalizePrice(row.globalKrwPrice)
        return {
          x,
          date: row.priceDate,
          domesticPrice,
          globalPrice,
          domesticY: toY(domesticPrice),
          globalY: toY(globalPrice),
        }
      })
    },
    longMarketYAxisTicks() {
      const box = this.longMarketChartBox
      const scale = this.longMarketScale
      const count = 6
      return Array.from({ length: count }, (_, index) => {
        const ratio = index / (count - 1)
        const value = scale.max - scale.spread * ratio
        return {
          value,
          y: box.top + (box.bottom - box.top) * ratio,
          label: this.formatAxisWon(value),
        }
      })
    },
    longMarketXAxisTicks() {
      const points = this.longMarketChartPoints
      if (!points.length) return []
      const byYear = new Map()
      points.forEach(point => {
        const year = String(point.date || '').slice(0, 4)
        if (year && !byYear.has(year)) byYear.set(year, point.x)
      })
      const ticks = Array.from(byYear.entries()).map(([label, x]) => ({ label, x }))
      if (ticks.length <= 6) return ticks
      const step = (ticks.length - 1) / 5
      return Array.from({ length: 6 }, (_, index) => ticks[Math.round(index * step)])
    },
    domesticLinePath() {
      return this.linePathFor('domesticY')
    },
    globalLinePath() {
      return this.linePathFor('globalY')
    },
    domesticAreaPath() {
      return this.areaPathFor('domesticY')
    },
    globalAreaPath() {
      return this.areaPathFor('globalY')
    },
    longMarketActivePoint() {
      const points = this.longMarketChartPoints
      if (!points.length) return null
      if (Number.isInteger(this.longMarketHoverIndex) && points[this.longMarketHoverIndex]) {
        return points[this.longMarketHoverIndex]
      }
      return [...points].reverse().find(point => Number.isFinite(point.domesticY) || Number.isFinite(point.globalY)) || null
    },
    longMarketTooltipPoint() {
      const point = this.longMarketActivePoint
      if (!point) return null
      const visibleYValues = [point.domesticY, point.globalY].filter(Number.isFinite)
      const anchorY = visibleYValues.length ? Math.min(...visibleYValues) : this.longMarketChartBox.top
      const series = [
        {
          key: 'domestic',
          label: '국내',
          color: '#202632',
          y: point.domesticY,
          text: Number.isFinite(point.domesticPrice) ? this.formatWon(point.domesticPrice) : '데이터 없음',
          hasValue: Number.isFinite(point.domesticPrice),
        },
        {
          key: 'global',
          label: '해외',
          color: '#1388ff',
          y: point.globalY,
          text: Number.isFinite(point.globalPrice) ? this.formatWon(point.globalPrice) : '데이터 없음',
          hasValue: Number.isFinite(point.globalPrice),
        },
      ].sort((a, b) => {
        if (Number.isFinite(a.y) && Number.isFinite(b.y)) return a.y - b.y
        if (Number.isFinite(a.y)) return -1
        if (Number.isFinite(b.y)) return 1
        return 0
      })
      const tooltipWidth = this.longMarketTooltipWidth
      const boxX = Math.min(Math.max(point.x - tooltipWidth / 2, this.longMarketChartBox.left), this.longMarketChartBox.right - tooltipWidth)
      const boxY = Math.max(this.longMarketChartBox.top + 8, anchorY - 86)
      return {
        ...point,
        boxX,
        boxY,
        boxWidth: tooltipWidth,
        boxHeight: 74,
        monthLabel: this.formatYearMonth(point.date),
        series,
      }
    },
    longMarketLatestPrice() {
      const latest = [...(this.longMarketChartPoints || [])].reverse().find(point => point.domesticPrice || point.globalPrice)
      return latest?.domesticPrice || latest?.globalPrice || null
    },
    longMarketLatestDate() {
      const latest = [...(this.longMarketChartPoints || [])].reverse().find(point => point.domesticPrice || point.globalPrice)
      return latest?.date || ''
    },
    longMarketSummary() {
      const primaryValues = (this.longMarketChartPoints || [])
        .map(point => point.domesticPrice || point.globalPrice)
        .filter(value => Number.isFinite(value) && value > 0)
      if (!primaryValues.length) {
        return { open: null, high: null, low: null, close: null }
      }
      return {
        open: primaryValues[0],
        high: Math.max(...primaryValues),
        low: Math.min(...primaryValues),
        close: primaryValues[primaryValues.length - 1],
      }
    },
  },

  methods: {
    compactAmount(value) {
      const amount = Number(value || 0)
      if (amount >= 100000000) {
        const hundredMillion = amount / 100000000
        return `${hundredMillion >= 10 ? Math.round(hundredMillion) : hundredMillion.toFixed(1)}억원`
      }
      if (amount >= 10000) return `${Math.round(amount / 10000).toLocaleString('ko-KR')}만원`
      return `${amount.toLocaleString('ko-KR')}원`
    },
    compactCount(value) {
      const count = Number(value || 0)
      if (count >= 10000) {
        const tenThousand = count / 10000
        return `${tenThousand >= 10 ? Math.round(tenThousand) : tenThousand.toFixed(1)}만명`
      }
      return `${count.toLocaleString('ko-KR')}명`
    },
    async fetchMarketPrices() {
      this.marketPriceLoading = true
      this.longMarketHoverIndex = null
      try {
        const res = await getMarketPriceLongHistory({
          metal: this.activeMetal.toUpperCase(),
          range: this.activeDateRange,
          unit: this.activeWeightUnit,
        })
        if (res.data?.code !== 0) return
        this.longMarketPoints = res.data.points || []
      } catch (e) {
        console.warn('[HomeView] long market price fetch failed:', e)
      } finally {
        this.marketPriceLoading = false
      }
    },
    setActiveMetal(metal) {
      if (this.activeMetal === metal) return
      this.activeMetal = metal
      this.longMarketHoverIndex = null
      this.fetchMarketPrices()
    },
    setActiveWeightUnit(unit) {
      if (this.activeWeightUnit === unit) return
      this.activeWeightUnit = unit
      this.longMarketHoverIndex = null
      this.fetchMarketPrices()
    },
    setActiveDateRange(range) {
      if (this.activeDateRange === range) return
      this.activeDateRange = range
      this.longMarketHoverIndex = null
      this.fetchMarketPrices()
    },
    handleLongMarketMouseMove(event) {
      const points = this.longMarketChartPoints
      if (!points.length) return

      const rect = event.currentTarget.getBoundingClientRect()
      const x = ((event.clientX - rect.left) / rect.width) * this.longMarketChartBox.width
      const nearest = points.reduce((closest, point, index) => {
        const distance = Math.abs(point.x - x)
        return distance < closest.distance ? { index, distance } : closest
      }, { index: 0, distance: Number.POSITIVE_INFINITY })
      this.longMarketHoverIndex = nearest.index
    },
    clearLongMarketHover() {
      this.longMarketHoverIndex = null
    },
    linePathFor(yKey) {
      const points = this.longMarketChartPoints.filter(point => Number.isFinite(point[yKey]))
      if (!points.length) return ''
      return points
        .map((point, index) => (index === 0 ? 'M' : 'L') + point.x.toFixed(2) + ',' + point[yKey].toFixed(2))
        .join(' ')
    },
    areaPathFor(yKey) {
      const points = this.longMarketChartPoints.filter(point => Number.isFinite(point[yKey]))
      if (!points.length) return ''
      const baseline = this.longMarketChartBox.bottom
      const line = points
        .map((point, index) => (index === 0 ? 'M' : 'L') + point.x.toFixed(2) + ',' + point[yKey].toFixed(2))
        .join(' ')
      const last = points[points.length - 1]
      const first = points[0]
      return `${line} L${last.x.toFixed(2)},${baseline} L${first.x.toFixed(2)},${baseline} Z`
    },
    lastPointFor(yKey) {
      const point = [...this.longMarketChartPoints].reverse().find(item => Number.isFinite(item[yKey]))
      return point ? { x: point.x, y: point[yKey] } : null
    },
    formatNumber(value) {
      const number = Number(value)
      return Number.isFinite(number) ? Math.round(number).toLocaleString() : '-'
    },
    formatWon(value) {
      const number = this.formatNumber(value)
      return number === '-' ? '-' : `${number}원`
    },
    formatAxisWon(value) {
      const number = Number(value)
      if (!Number.isFinite(number)) return '-'
      if (number >= 100000000) return `${(number / 100000000).toLocaleString('ko-KR', { maximumFractionDigits: 1 })}억원`
      if (number >= 10000) return `${Math.round(number / 10000).toLocaleString('ko-KR')}만원`
      return `${Math.round(number).toLocaleString('ko-KR')}원`
    },
    formatYearMonth(value) {
      if (!value) return '-'
      const text = String(value)
      if (/^\d{4}-\d{2}/.test(text)) return text.slice(0, 7)
      return text
    },
    formatSignedWon(value) {
      const number = Number(value)
      if (!Number.isFinite(number)) return '-'
      const rounded = Math.round(number)
      const sign = rounded > 0 ? '+' : ''
      return `${sign}${rounded.toLocaleString()}원`
    },
    formatPercent(value) {
      const number = Number(value)
      if (!Number.isFinite(number)) return '-'
      const sign = number > 0 ? '+' : ''
      return `${sign}${number.toFixed(2)}%`
    },
    async fetchMainDisplay() {
      try {
        const res = await getMainDisplay()
        if (res.data?.code !== 0) {
          this.mainProducts = []
          this.coinProducts = []
          return
        }
        const mainBanners = res.data.mainBanners || []
        const promotionBanners = res.data.promotionBanners || []
        if (mainBanners.length) {
          this.setHeroBanners(mainBanners)
        }
        if (promotionBanners.length) {
          this.promoBanners = promotionBanners.map(item => ({
            image: item.imageUrl || promotion01,
            label: item.title || '기획전 바로가기 →',
            linkUrl: item.linkUrl,
          }))
        }
      } catch (e) {
        console.warn('[HomeView] main display fetch failed:', e)
      } finally {
        this.mainDisplayLoaded = true
      }
    },
    async fetchHomeProductSections() {
      this.mainDisplayLoaded = false
      try {
        const [labelRes, brandRes] = await Promise.all([
          getProductLabels(),
          getProductBrands(),
        ])
        this.productLabelTabs = Array.isArray(labelRes.data) ? labelRes.data : []
        this.brandTabs = Array.isArray(brandRes.data) ? brandRes.data : []
        this.activeProductLabelKey = this.productLabelTabs[0]?.labelKey || ''
        this.activeBrandCode = this.brandTabs[0]?.brandCode || ''

        await Promise.all([
          this.fetchMainProductsByLabel(),
          this.fetchCollectionProductsByBrand(),
        ])
      } catch (e) {
        console.warn('[HomeView] home product sections fetch failed:', e)
        this.productLabelTabs = []
        this.brandTabs = []
        this.mainProducts = []
        this.coinProducts = []
      } finally {
        this.mainDisplayLoaded = true
      }
    },
    async selectProductLabel(labelKey) {
      if (this.activeProductLabelKey === labelKey) return
      this.activeProductLabelKey = labelKey
      await this.fetchMainProductsByLabel()
    },
    async selectBrandTab(brandCode) {
      if (this.activeBrandCode === brandCode) return
      this.activeBrandCode = brandCode
      await this.fetchCollectionProductsByBrand()
    },
    async fetchMainProductsByLabel() {
      if (!this.activeProductLabelKey) {
        this.mainProducts = []
        return
      }
      const res = await getProducts({ labelKey: this.activeProductLabelKey, page: 1, size: 8, sort: 'latest' })
      this.mainProducts = (res.data?.items || []).map(this.mapDisplayProduct)
    },
    async fetchCollectionProductsByBrand() {
      if (!this.activeBrandCode) {
        this.coinProducts = []
        return
      }
      const res = await getProducts({ brandCode: this.activeBrandCode, page: 1, size: 8, sort: 'latest' })
      this.coinProducts = (res.data?.items || []).map(this.mapDisplayProduct)
    },
    setHeroBanners(mainBanners) {
      const banners = mainBanners
        .filter(item => item.imageUrl)
        .map(item => ({
          imageUrl: item.imageUrl,
          title: item.title || item.subtitle || 'GOLDNARA main banner',
          linkUrl: item.linkUrl,
        }))

      if (!banners.length) return

      this.heroBanners = banners
      this.activeHeroDot = 0
      this.startHeroAutoSlide()
    },
    startHeroAutoSlide() {
      this.stopHeroAutoSlide()
      if (this.heroBanners.length <= 1) return
      this.heroTimer = window.setInterval(() => {
        this.nextHero()
      }, 15000)
    },
    stopHeroAutoSlide() {
      if (this.heroTimer) {
        window.clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    mapDisplayProduct(item) {
      const priceDisplayType = item.priceDisplayType || 'MARKET'
      const salePrice = this.salePrice(item)
      const hasDiscount = this.hasDiscount(item)
      return {
        productCode: item.productCode,
        branchProductCode: item.branchProductCode,
        branchName: item.branchName,
        allowedPaymentTypes: item.allowedPaymentTypes || ['CASH', 'CARD'],
        image: item.imageUrl || mainProduct01,
        title: item.title || item.productName || '상품명 없음',
        price: priceDisplayType === 'CONTACT' ? '가격문의' : (priceDisplayType === 'FIXED' && salePrice > 0 ? this.formatWon(salePrice) : '상품시세적용'),
        priceValue: priceDisplayType === 'FIXED' ? salePrice : 0,
        priceDisplayType,
        originalPrice: hasDiscount ? this.formatWon(item.originalPrice) : '',
        discountText: this.discountText(item),
        discountRateText: Number(item.discountRate) > 0 ? `${this.formatRate(item.discountRate)}%` : '',
        labels: item.labels || [],
        weight: item.weight,
        purity: item.purity,
        tags: item.brandName ? [item.brandName] : [],
        linkUrl: item.linkUrl || (item.productCode ? `/product-detail?productCode=${encodeURIComponent(item.productCode)}${item.branchProductCode ? `&branchProductCode=${encodeURIComponent(item.branchProductCode)}` : ''}` : '/products'),
      }
    },
    goDisplayProduct(product) {
      const linkUrl = product?.linkUrl || '/products'
      if (/^https?:\/\//i.test(linkUrl)) {
        window.open(linkUrl, '_blank', 'noopener,noreferrer')
        return
      }
      this.$router.push(linkUrl)
    },
    hasDiscount(item) {
      return Boolean(
        item?.priceDisplayType === 'FIXED'
          && Number(item.originalPrice) > 0
          && item.discountType
          && item.discountType !== 'NONE'
          && (Number(item.discountRate) > 0 || Number(item.discountAmount) > 0),
      )
    },
    discountText(item) {
      if (!this.hasDiscount(item)) return ''
      if (item.discountLabel) return item.discountLabel
      if (Number(item.discountRate) > 0) return `${this.formatRate(item.discountRate)} % off`
      if (Number(item.discountAmount) > 0) return `${this.formatWon(item.discountAmount)} 할인`
      return '할인'
    },
    labelBadgeClass(index) {
      return ['product-label-badge--outline', 'product-label-badge--soft', 'product-label-badge--solid'][index % 3]
    },
    updateMarketChartViewport() {
      this.isMobileMarketChart = window.innerWidth < 640
    },
    productSpecText(item) {
      const weightText = this.weightText(item)
      if (!weightText) return ''
      return `중량 ${weightText}`
    },
    weightText(item) {
      const weight = Number(item?.weight)
      if (!Number.isFinite(weight) || weight <= 0) return ''
      const gram = this.formatDecimal(weight, 3)
      const don = this.formatDecimal(weight / 3.75, 2)
      return `${gram}g / ${don}돈`
    },
    purityText(item) {
      const purity = Number(item?.purity)
      if (!Number.isFinite(purity) || purity <= 0) return ''
      return this.formatDecimal(purity, 3)
    },
    formatDecimal(value, maxDigits) {
      return Number(value).toLocaleString('ko-KR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxDigits,
      })
    },
    salePrice(item) {
      const originalPrice = Number(item?.originalPrice || 0)
      if (!this.hasDiscount(item)) return originalPrice

      if (Number(item.discountRate) > 0) {
        return Math.max(0, Math.round(originalPrice * (100 - Number(item.discountRate)) / 100))
      }
      if (Number(item.discountAmount) > 0) {
        return Math.max(0, originalPrice - Number(item.discountAmount))
      }
      return originalPrice
    },
    formatRate(value) {
      const number = Number(value)
      if (Number.isNaN(number)) return value
      return Number.isInteger(number) ? String(number) : number.toLocaleString('ko-KR')
    },
    animateCounter(key, target, duration) {
      const start = performance.now()
      const update = (now) => {
        const elapsed = now - start
        const progress = Math.min(elapsed / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        this[key] = Math.floor(eased * target)
        if (progress < 1) requestAnimationFrame(update)
        else this[key] = target
      }
      requestAnimationFrame(update)
    },
    prevHero() {
      if (!this.heroBanners.length) return
      this.activeHeroDot = (this.activeHeroDot - 1 + this.heroBanners.length) % this.heroBanners.length
    },
    nextHero() {
      if (!this.heroBanners.length) return
      this.activeHeroDot = (this.activeHeroDot + 1) % this.heroBanners.length
    },
    goHero(idx) {
      this.activeHeroDot = idx
      this.startHeroAutoSlide()
    },
    addToCart(item) {
      if (!item.productCode) {
        this.$router.push('/products')
        return
      }
      if (item.priceDisplayType === 'CONTACT') {
        this.goToPriceInquiry(item)
        return
      }
      this.cartStore.addItem({
        productCode: item.productCode,
        branchProductCode: item.branchProductCode,
        branchName: item.branchName,
        title: item.title,
        price: item.priceValue || 0,
        priceDisplayType: item.priceDisplayType || 'MARKET',
        qty: 1,
        imageUrl: item.image,
        allowedPaymentTypes: item.allowedPaymentTypes || ['CASH', 'CARD'],
        selectedPaymentType: this.defaultPaymentType(item.allowedPaymentTypes),
      })
      this.$router.push('/cart')
    },
    goToPriceInquiry(item) {
      const target = {
        path: '/my/inquiries/new',
        query: {
          type: 'PRODUCT_PRICE',
          productCode: item.productCode,
          ...(item.branchProductCode ? { branchProductCode: item.branchProductCode } : {}),
        },
      }
      if (!this.authStore.isLoggedIn) {
        this.$router.push({ path: '/login', query: { redirect: this.$router.resolve(target).fullPath } })
        return
      }
      this.$router.push(target)
    },
    defaultPaymentType(types) {
      const allowed = Array.isArray(types) && types.length ? types : ['CASH', 'CARD']
      return allowed.length === 1 ? allowed[0] : ''
    },
    scrollProductRow(refName, direction) {
      const scroller = this.$refs[refName]
      if (!scroller) return
      const firstCard = scroller.querySelector('.product-carousel-card')
      const gap = 24
      const amount = firstCard ? firstCard.getBoundingClientRect().width + gap : scroller.clientWidth
      scroller.scrollBy({ left: amount * direction, behavior: 'smooth' })
    },
  },
}
</script>

<style scoped>
.home-sky-gradient-start {
  background:
    radial-gradient(circle at 50% 100%, rgba(208, 235, 250, 0.62) 0%, rgba(229, 245, 253, 0.34) 48%, rgba(255, 255, 255, 0) 78%),
    linear-gradient(180deg, #ffffff 0%, #ffffff 18%, rgba(248, 253, 255, 0.72) 46%, #eef9fe 78%, #e8f6fd 100%);
}

.home-sky-gradient-combined {
  background:
    radial-gradient(circle at 50% 22%, rgba(201, 232, 248, 0.7) 0%, rgba(226, 244, 253, 0.4) 40%, rgba(248, 253, 255, 0.15) 68%),
    linear-gradient(180deg, #e8f6fd 0%, #edf9ff 22%, #e9f7fe 46%, #eefaff 68%, #f8fdff 84%, #ffffff 100%);
}

.trust-metrics {
  min-height: 84px;
}

.trust-metric-number {
  font-size: clamp(18px, 5.3vw, 34px);
  letter-spacing: 0;
  word-break: keep-all;
}

.trust-metric-label {
  font-size: clamp(10px, 2.7vw, 16px);
  word-break: keep-all;
  white-space: nowrap;
}

@keyframes marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

.marquee-track {
  display: flex;
  width: max-content;
  animation: marquee 24s linear infinite;
}

.partner-marquee-segment {
  display: flex;
  align-items: center;
  gap: 48px;
  padding-right: 48px;
}

@media (min-width: 640px) {
  .partner-marquee-segment {
    gap: 88px;
    padding-right: 88px;
  }
}

.marquee-track:hover {
  animation-play-state: paused;
}

.product-carousel-row {
  display: flex;
  gap: 24px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  padding: 2px 2px 10px;
}

.product-carousel-row::-webkit-scrollbar {
  display: none;
}

.product-carousel-card {
  flex: 0 0 calc((100% - 72px) / 4);
  scroll-snap-align: start;
}

.carousel-nav {
  position: absolute;
  top: 50%;
  z-index: 5;
  display: flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 24px rgba(0, 38, 77, 0.12);
  color: #00284a;
  font-size: 34px;
  line-height: 1;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.carousel-nav:hover {
  background: #ffffff;
  transform: translateY(-50%) scale(1.04);
}

.carousel-nav--left {
  left: -21px;
}

.carousel-nav--right {
  right: -21px;
}

@media (max-width: 1023px) {
  .product-carousel-card {
    flex-basis: calc((100% - 48px) / 3);
  }
}

@media (max-width: 639px) {
  .product-carousel-row {
    gap: 12px;
  }

  .product-carousel-card {
    flex-basis: calc((100% - 12px) / 2);
  }

  .carousel-nav {
    width: 36px;
    height: 36px;
    font-size: 28px;
  }

  .carousel-nav--left {
    left: -10px;
  }

  .carousel-nav--right {
    right: -10px;
  }

  .trust-metrics {
    border-radius: 0;
  }

  .trust-metric-item {
    min-width: 0;
    min-height: 76px;
  }
}

.marquee-wrapper::before,
.marquee-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 80px;
  z-index: 2;
  pointer-events: none;
}

.marquee-wrapper::before {
  left: 0;
  background: linear-gradient(to right, #f8fafd, transparent);
}

.marquee-wrapper::after {
  right: 0;
  background: linear-gradient(to left, white, transparent);
}
</style>
